import React from 'react';

import NotFound from '@components/NotFound';

import OrgSettingLayout from '@views/Organization/OrgSettingManagementLayout';

export default function ManageOrgTasksPage(props: PagePropsWithBreadcrumbs) {
  return (
    <OrgSettingLayout pageProps={props}>{() => <NotFound />}</OrgSettingLayout>
  );
}
